import { inject, Injectable } from '@angular/core';
import { TokenAbstractService } from '../abstract/token-abstract.service';
import { LegacyTokenHandler } from '../handlers/legacy-token-handler/legacy-token.handler';
import { TokenHandler } from '../handlers/token-handler/token.handler';
import { AuthConfigService } from '../../auth-config/auth-config.service';
import { AuthProvider, LoginResponseInterface } from '../../../models';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TokenService {
  #authConfigService = inject(AuthConfigService);

  #handlers: Map<string, TokenAbstractService> = new Map<string, TokenAbstractService>([
    [AuthProvider.Cognito, inject(TokenHandler)],
    [AuthProvider.Legacy, inject(LegacyTokenHandler)],
  ]);

  setToken(response: LoginResponseInterface): void {
    Array.from(this.#handlers.values()).forEach((handler) => handler.setToken(response));
  }

  getValidToken(): Observable<string | null> {
    const handlerWithToken = this.getHandlerWithToken();
    return handlerWithToken ? handlerWithToken.getValidToken() : of(null);
  }

  removeToken(): void {
    Array.from(this.#handlers.values()).forEach((handler) => handler.removeToken());
  }

  getWebsiteId(): number | null {
    return this.getHandlerWithToken()?.getWebsiteId();
  }

  getEmail(): string | null {
    return this.getHandlerWithToken()?.getEmail();
  }

  getAccessToken(): string | null {
    return (this.#handlers.get(AuthProvider.Cognito) as TokenHandler)?.getAccessToken();
  }

  getRole(): string | string[] | null {
    return this.getHandlerWithToken()?.getRole();
  }

  private getHandlerWithToken(): TokenAbstractService | undefined {
    return Array.from(this.#handlers.values()).find((handler) => handler.isHoldingAToken());
  }
}
